import React from "react";
import Customers2 from "./Customers2";

const Customers = () => {
  return (
    <div>
    <div className="bg-gray-50 min-h-screen p-4 md:p-8">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 mb-3 md:mb-0">
          Customers
        </h1>

        {/* Action buttons */}
        <div className="flex space-x-2">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm">
            + Add new
          </button>
          <button className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm">
            Export
          </button>
          <button className="bg-emerald-500 hover:bg-emerald-600 text-white px-3 py-1 rounded text-sm">
            Import
          </button>
        </div>
      </div>

      {/* Search Section */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-4">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16l4-4m0 0l4-4m-4 4H3m13 4h6"
              />
            </svg>
            <h2 className="text-lg font-medium text-gray-800">Search</h2>
          </div>

          <button className="text-gray-500 hover:text-gray-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          </button>
        </div>

        {/* Form Fields */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left column */}
          <div className="space-y-3">
            <div>
              <label className="text-gray-700 font-medium">Email</label>
              <input
                type="email"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                placeholder="Enter email"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">First name</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                placeholder="Enter first name"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">Last name</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                placeholder="Enter last name"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">Is active</label>
              <select className="w-full border border-gray-300 rounded px-3 py-2 mt-1">
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            <div>
              <label className="text-gray-700 font-medium">
                Registration date from
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">
                Registration date to
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-3">
            <div>
              <label className="text-gray-700 font-medium">
                Last activity from
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">
                Last activity to
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">Company</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                placeholder="Enter company"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">IP address</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                placeholder="Enter IP"
              />
            </div>

            <div>
              <label className="text-gray-700 font-medium">Customer roles</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                defaultValue="Registered"
              />
            </div>
          </div>
        </form>

        {/* Search Button */}
        <div className="mt-6 flex justify-center">
          <button className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            Search
          </button>
        </div>
      </div>
    </div>
<Customers2 />
    </div>
  );
};

export default Customers;
